import { type } from '@ngrx/signals'
import { eventGroup } from '@ngrx/signals/events'

import type { ConversationProfile } from '@app/modules/messaging/models/conversation-profile.model'
import type { S3BatchFileUpload } from '@app/modules/s3-upload/core/s3-batch-file-upload'

import type { UnsentVoiceMessage } from '../models/voice-message.model'

export const voiceUploadEvents = eventGroup({
  source: 'Voice Upload',
  events: {
    uploadStart: type<void>(),
    uploadComplete: type<{
      batchUpload: S3BatchFileUpload
      voice: UnsentVoiceMessage | undefined
      profile: ConversationProfile
      flow: string
    }>(),
    uploadEnd: type<void>(),
  },
})
